import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const DEFAULT_CONFIG = {
  services: {
    noLabour: { base: 40, perKm: 1.4, includedKm: 25 },
    driverHelp: { base: 64, perKm: 1.6, includedKm: 25 },
    twoMen: { base: 99, perKm: 1.8, includedKm: 25 },
  },
  durations: { "30": 0, "60": 18, "90": 32, "120": 45, "180": 65 },
  blockedDates: [],
  phoneRaw: "+358401683383",
  phoneDisplay: "+358 40 168 3383",
  whatsappLink: "https://wa.me/358401683383",
  faqItems: [],
  whyItems: [],
  trustBadges: [],
  colors: null,
  heroImage: "",
};

/**
 * Fetches the live pricing config from the backend on mount.
 * Re-fetches when the "anypaku-config-changed" event fires
 * (after the admin saves new values).
 */
export const useConfig = () => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const data = await api.getConfig();
      setConfig({ ...DEFAULT_CONFIG, ...data });
    } catch {
      /* keep defaults if API unreachable */
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
    const handler = () => refresh();
    window.addEventListener("anypaku-config-changed", handler);
    return () => window.removeEventListener("anypaku-config-changed", handler);
  }, [refresh]);

  return { ...config, _loaded: loaded };
};
